import { difference, pick, isEmpty } from '@/helpers/utilities';
import filterAttributesQueries from '@/helpers/search-client/attributes';
import queryMixins from '@/mixins/query';
import searchMixin from '@/mixins/search';

export default {
  props: {
    type: {
      type: String,
      default: 'expansion',
    },
  },
  mixins: [searchMixin, queryMixins],
  computed: {
    filterOptions() {
      if (!this.state('search')) return {};
      return this.state('search.filtersOptions');
    },
    filterValues() {
      if (!this.state('search') || !this.state('search.filtersOptions')) return {};
      if (Array.isArray(this.filterName)) {
        return pick(this.state('search.filtersOptions'), this.filterName);
      }
      return this.state('search.filtersOptions')[this.filterName] || {};
    },
  },
  methods: {
    /**
     * Remove a specific filter based on param / filterName of the component
     * @param {string - default to null} filterName name of the filter in searchCriteria
     * @return null
     */
    removeSearchCriteria(filterName = null) {
      const removeFilterName = filterName || this.filterName;
      const searchCriteria = Object.keys({ ...this.searchCriteria }).reduce((object, n) => {
        if (removeFilterName === n) return object;
        const newObject = { ...object };
        newObject[n] = this.searchCriteria[n];
        return newObject;
      }, {});

      this.commit('search/setValues', [{
        key: 'searchCriteria',
        value: searchCriteria,
      }, {
        key: 'currentPage',
        value: 1,
      }]);
    },

    /**
     * update searchCriteria based on param or filtername of the component
     * @param {array / object} value value to update to the search criteria
     * @param {string - default to null} filterName a specific filterName you want to update
     * @return null
     */
    updateSearchCriteria(value, filterName = null) {
      const filterToUpdate = filterName || this.filterName;
      const searchCriteria = { ...this.searchCriteria };

      searchCriteria[filterToUpdate] = Array.isArray(value) ? [...value] : { ...value };
      this.commit('search/setValues', [{
        key: 'searchCriteria',
        value: searchCriteria,
      }, {
        key: 'currentPage',
        value: 1,
      }]);
    },

    /**
     * Call this function to do the search and obtain the vehicles
     */
    loadSearchFilters() {
      this.commit('search/updateEnabledFilters', this.filterName);
      this.dispatch('search/setAvailableFiltersOptions');
    },
    filterMixinInit() {
      const whitelist = Object.keys(filterAttributesQueries);
      const array = Array.isArray(this.filterName) ? this.filterName : [this.filterName];
      const diff = difference(array, whitelist);
      if (diff.length !== 0) return;
      // if the filter option already exists do not load again
      if (this.filterValues !== undefined && !isEmpty(this.filterValues)) return;
      this.loadSearchFilters();
    },
    async afterModulesLoaded() {
      this.filterMixinInit();
    },
  },
};
